
export default {
    jwt: null,
    error: false,
    isLoading1: false,
    isLoading2: false,
    responseMsg: null,
    apiDomain: 'https://api.texasavesocial.com',
    user: null,
    users: [],
    guestUser: null,
    searchedUsers: [],
    broadcast: null,
    broadcasts: [],
    broadcast_group: null,
    broadcast_groups: [],
    table: [],
    tables: [],
}
